import type React from 'react';

import { DeleteIcon } from '@vlabs/icons';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { confirmDeleteSourceGroup } from './confirm/confirmDeleteSourceGroup';
import { useDeleteSourceGroup } from './useDeleteSourceGroup';
import { useDeleteSourceGroupTranslation } from '../i18n';
import type { DeleteSourceGroupProps } from '../types';

interface DeleteSourceGroupButtonProps extends DeleteSourceGroupProps, WithDataTestid, ButtonProps {}

function DeleteSourceGroupButton({
  groupId,
  onDeleted = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DeleteSourceGroupButtonProps): React.JSX.Element {
  const { t } = useDeleteSourceGroupTranslation();
  const { onDelete } = useDeleteSourceGroup({ groupId, onDeleted });

  return (
    <Button
      data-testid={dataTestId}
      icon={<DeleteIcon />}
      kind="negative"
      onClick={() => confirmDeleteSourceGroup({ onConfirm: onDelete })}
      variant="outlined"
      {...props}
    >
      {t('title')}
    </Button>
  );
}

export { DeleteSourceGroupButton };
